var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import theme from '../consts/theme';
var baseStyles = css((_a = {
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        fontSize: '1rem',
        lineHeight: 1.5,
        padding: 0,
        width: '100%'
    },
    _a[theme.breakpoints.md] = {
        width: 'auto',
    },
    _a['&:disabled'] = {
        cursor: 'default',
        opacity: 0.5,
        pointerEvents: 'none',
    },
    _a));
var buttonStyles = css((_b = {
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: 1,
        border: '1px solid transparent',
        borderRadius: 9999,
        display: 'inline-block',
        padding: '0.75rem 1.5rem',
        textAlign: 'center',
        transitionDuration: '150ms',
        transitionProperty: 'background-color, border-color, color',
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
    },
    _b[theme.breakpoints.lg] = {
        padding: '1rem 2rem',
    },
    _b));
var stylesByVariant = {
    primary: css({
        backgroundColor: theme.colors.helsinkiBlueDark,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.colors.ensoBlue,
            color: theme.colors.helsinkiBlue,
        },
    }),
    reverse: css({
        borderColor: theme.colors.helsinkiBlueDark,
        color: theme.colors.helsinkiBlueDark,
        '&:hover': {
            backgroundColor: theme.colors.helsinkiBlueDark,
            color: theme.colors.white,
        },
    }),
    basic: css({
        color: 'inherit',
    }),
};
var Button = function (_a) {
    var children = _a.children, css = _a.css, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, props = __rest(_a, ["children", "css", "type", "variant"]);
    var styles = [baseStyles];
    // Add button styles for pill-style buttons
    if (variant !== 'basic')
        styles.push(buttonStyles);
    styles.push(stylesByVariant[variant]);
    if (css)
        styles.push(css);
    return (_jsx("button", __assign({ css: styles, type: type, "data-variant": variant }, props, { children: children })));
};
export default Button;
//# sourceMappingURL=data:application/json;base64,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